import axios from 'axios';
import type { Role } from '../types/Role';
import type { Permission } from '../types/User';

const BASE_URL = process.env.REACT_APP_API_URL;

interface PaginatedResponse<T> {
  roles: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const rolesService = {
  getRoles: async (
    page: number = 1,
    limit: number = 25,
    search: string = '',
    sortBy?: string,
    sortOrder?: 'asc' | 'desc'
  ): Promise<PaginatedResponse<Role>> => {
    const response = await axios.get(`${BASE_URL}/roles`, {
      params: { page, limit, search: search || undefined, sortBy: sortBy || undefined, sortOrder: sortOrder || undefined }
    });
    return response.data;
  },

  getRole: async (id: number): Promise<Role> => {
    const response = await axios.get(`${BASE_URL}/roles/${id}`);
    return response.data;
  },

  createRole: async (roleData: Partial<Role>): Promise<Role> => {
    const response = await axios.post(`${BASE_URL}/roles`, roleData);
    return response.data;
  },

  updateRole: async (id: number, roleData: Partial<Role>): Promise<Role> => {
    const response = await axios.put(`${BASE_URL}/roles/${id}`, roleData);
    return response.data;
  },

  deleteRole: async (id: number): Promise<void> => {
    await axios.delete(`${BASE_URL}/roles/${id}`);
  },

  getPermissions: async (): Promise<Permission[]> => {
    const response = await axios.get(`${BASE_URL}/roles/permissions/all`);
    return response.data;
  },

  updateRolePermissions: async (roleId: number, permissionIds: number[]): Promise<Role> => {
    const response = await axios.put(`${BASE_URL}/roles/${roleId}/permissions`, {
      permissionIds
    });
    return response.data;
  }
};